import { Link } from "react-router-dom"
import Alert from "./alert"
import { useMessages } from "../language/language"
import { usePlayState } from "play/hooks/use-play-state"
import { format } from "utils/helpers"

/**
 * Tells a signed-in user whose email the mail sender refuses (registered before
 * the address check) that our mail does not reach them; with `linkToProfile`,
 * links to the profile page, where the address is changed. Renders nothing for
 * everyone else.
 */
export default function EmailUndeliverableAlert(props: {
  linkToProfile?: boolean
}) {
  const { loggedUser } = usePlayState()
  const msg = useMessages()

  if (!loggedUser?.emailUndeliverable) return null

  return (
    <div className="email-undeliverable">
      <Alert type="warning">
        {format(msg.profile_emailUndeliverable, loggedUser.email)}
        {props.linkToProfile && (
          <>
            {" "}
            <Link to="/profile" className="alert-link">
              {msg.profile_emailUndeliverableFix}
            </Link>
          </>
        )}
      </Alert>
    </div>
  )
}
